import { Component, input, output } from '@angular/core';


export interface MenuDropdownButtonItem {
  routerLink: string;
  label: string;
  icon: string;
}

@Component({
  standalone: true,
  imports: [],
  selector: 'lib-menu-dropdown-button',
  template: `
    <button
      (click)="onItemClick.emit(item().routerLink)"
      class="w-full text-left px-4 py-2 text-sm text-gray-200 hover:bg-gray-700 hover:text-white transition-colors duration-200 focus:outline-none focus:bg-gray-700"
    >
      <div class="flex items-center">
        <svg
          class="w-4 h-4 mr-3 flex-shrink-0"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            [attr.d]="item().icon"
          />
        </svg>
        <span class="truncate">{{ item().label }}</span>
      </div>
    </button>
  `,
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
})
export class MenuDropdownButtonComponent {
  item = input.required<MenuDropdownButtonItem>();
  onItemClick = output<string>();
}
